import { IQuote } from 'Quotes/types/store';
import Column from 'shared/components/atoms/Column';
import React from 'react';
import { Amount } from 'Order/OrderBuilder/QuoteSummary/TermAndPrice/index';
import { displayAnnualAmount } from 'Quotes/utils/priceDisplay';

export function FttpAggPrice(props: { quote: IQuote; amount: number; viewAsMonthly: boolean }) {
  return (
    <>
      {!!props.quote.fttpAggregation && (
        <Column defaultWidth={3}>
          <span className="mr-2">FTTP Aggregation</span>
          <Amount amount={displayAnnualAmount(props.amount, props.viewAsMonthly) ?? 0} />
        </Column>
      )}
    </>
  );
}
